import { render, staticRenderFns } from "./StatusMapping.vue?vue&type=template&id=4cd7017d"
import script from "./StatusMapping.vue?vue&type=script&lang=js"
export * from "./StatusMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports